import React, { useEffect, useRef } from 'react';
import _ from 'lodash';

import Tippy from '../ReactTippy';
import {
  getRoleNameByRoleId,
  isPrimaryCompanyRoleId,
} from '../../utilities/roleUtility';
import { INVITATION_STATUS } from '../../utilities/constants';
import { iosCheck } from '../../utilities/stringUtil';
import SessionStorageService from '../../services/utilities/SessionStorageService';

const headers = [
  { name: '', className: 'value-table--type' },
  { name: '所属会社名', className: '' },
  { name: '元請会社', className: '' },
  { name: 'ユーザー種別', className: '' },
  { name: '氏名', className: '' },
];

export const UserIntegrateTable = ({
  data,
  action = null,
  maxHeightTable = 404,
}) => {
  const refTable = useRef();

  useEffect(
    () => {
      if (
        !iosCheck() &&
        refTable.current.offsetHeight > Number(maxHeightTable)
      ) {
        refTable.current.classList.add('user-integrate-table--scroll');
      }
    },
    [data]
  );

  const renderToolTip = (value, invitationStatus) => {
    let invitationUnconfirmedMark = '';
    if (invitationStatus === INVITATION_STATUS.unconfirmed) {
      invitationUnconfirmedMark = 'NEW!';
    }
    return (
      <Tippy
        duration={10}
        distance={24}
        arrowType='sharp'
        delay={[500, 0]}
        placement='bottom'
        followCursor={true}
        role={`tippy_target_${_.uniqueId()}`}
        html={renderTooltipContent(value)}
      >
        <p className='value-table__txt--7'>
          {invitationUnconfirmedMark && (
            <span className='text--red--primary'>
              {invitationUnconfirmedMark}{' '}
            </span>
          )}
          {value}
        </p>
      </Tippy>
    );
  };

  const renderType = roleId => {
    if (roleId && isPrimaryCompanyRoleId(roleId)) {
      return <div className='badge badge--prime'>元請</div>;
    }
    return <div className='badge badge--partner'>協力</div>;
  };

  return (
    <table className='table user-integrate-table' ref={refTable}>
      <thead className='table__header user-integrate-table__header'>
        <tr className='table__label'>
          {_.map(headers, (item, index) => (
            <td
              className={`value-table value-table--table__label ${
                item.className
              }`}
              key={index}
            >
              <div className='value-table__label'>{item.name}</div>
            </td>
          ))}
          {action && (
            <td
              className={`value-table value-table--table__label value-table--action`}
            >
              <div className='value-table__label'>{''}</div>
            </td>
          )}
        </tr>
      </thead>
      <tbody
        style={{ maxHeight: maxHeightTable }}
        className='user-integrate-table__body'
      >
        {_.map(data, (item, index) => (
          <tr className='table__item' key={index}>
            <td className='value-table'>
              {renderType(_.get(item, 'user_role'))}
            </td>
            <td className='value-table'>
              {renderToolTip(
                _.get(item, 'company.name'),
                _.get(item, 'company.invitation_status')
              )}
            </td>
            <td className='value-table'>
              {renderToolTip(
                _.get(item, 'company.motouke_sentaku_name') || '-'
              )}
            </td>
            <td className='value-table'>
              <div>{getRoleNameByRoleId(_.get(item, 'user_role'))}</div>
            </td>
            <td className='value-table'>
              {renderToolTip(_.get(item, 'fullname', '-'))}
            </td>
            {action && (
              <td className='value-table value-table--action'>
                <div>
                  <button
                    className='btn--sm--sub'
                    onClick={() => {
                      SessionStorageService.removeLastCheckedTimeOfExpiration();
                      action(userIntegrateTableActionParam(item));
                    }}
                  >
                    選択
                  </button>
                </div>
              </td>
            )}
          </tr>
        ))}
      </tbody>
    </table>
  );
};

const renderTooltipContent = data => {
  const rowStyle = {
    wordWrap: 'break-word',
    whiteSpace: 'pre-wrap',
    color: '#FFF',
    fontSize: '14px',
    lineHeight: '1.5',
    textAlign: 'left',
    maxWidth: '240px',
  };

  return (
    <React.Fragment>
      <div style={rowStyle}>{data}</div>
    </React.Fragment>
  );
};

export const userIntegrateTableActionParam = item => {
  return {
    user_id: item.id,
    company_id: _.get(item, 'company.id'),
    company_branch_id: _.get(item, 'company.company_branch_id'),
    prime_company_id: _.get(item, 'company.prime_company_id'),
    partner_company_id: _.get(item, 'company.partner_company_id'),
    roleId: _.get(item, 'user_role'),
    partner_company_joining_flag: _.get(
      item,
      'company.partner_company_joining_flag'
    ),
    company_branches: _.get(item, 'company_branches') || null,
  };
};



// WEBPACK FOOTER //
// ./src/components/tables/UserIntegrateTable.jsx